import React, { useState, useEffect } from 'react';
import Cookie from 'js-cookie';
import { BASE_URL } from '../../config/constants';
import { useTranslation } from 'react-i18next';
function AddFaculty() {
	const { t } = useTranslation();
	const [facultyData, setFacultyData] = useState({
		name: '',
	});
	const [faculties, setFaculties] = useState([]);
	const [facultyId, setFacultyId] = useState('');
	const [isEditing, setIsEditing] = useState(false);
	const baseUrl = BASE_URL;
	useEffect(() => {
		fetchFaculties();
	}, []);

	const handleInputsValue = (e) => {
		const { name, value } = e.target;
		setFacultyData({
			...facultyData,
			[name]: value,
		});
	};

	const handleSubmitForm = async (e) => {
		e.preventDefault();

		try {
			const updatedFacultyData = {
				...facultyData,
			};

			const facultyResponse = await fetch(
				isEditing
					? `${baseUrl}/api/faculty/${facultyId}`
					: `${baseUrl}/api/faculty`,
				{
					method: isEditing ? 'PATCH' : 'POST',
					headers: {
						'Content-Type': 'application/json',
						Authorization: `Bearer ${Cookie.get('token')}`,
					},
					body: JSON.stringify(updatedFacultyData),
				}
			);

			if (facultyResponse.ok) {
				alert(
					isEditing
						? 'Faculty updated successfully'
						: 'Faculty added successfully'
				);
				setFacultyData({ name: '' });
				setFacultyId('');
				setIsEditing(false);
				fetchFaculties();
			} else {
				alert('Error saving faculty data');
			}
		} catch (error) {
			alert('Error uploading form!');
			console.error(error);
		}
	};

	const fetchFaculties = async () => {
		try {
			const response = await fetch(`${baseUrl}/api/faculty`, {
				method: 'GET',
				headers: {
					'Content-Type': 'application/json',
					Authorization: `Bearer ${Cookie.get('token')}`,
				},
			});
			if (response.ok) {
				const data = await response.json();
				setFaculties(data);
			}
		} catch (error) {
			console.error(error);
		}
	};

	const handleGetFacultyData = async (event) => {
		const selectedFacultyId = event.target.value;
		setFacultyId(selectedFacultyId);

		try {
			const response = await fetch(
				`${baseUrl}/api/faculty/${selectedFacultyId}`,
				{
					method: 'GET',
					headers: {
						'Content-Type': 'application/json',
						Authorization: `Bearer ${Cookie.get('token')}`,
					},
				}
			);

			if (response.ok) {
				const data = await response.json();
				setFacultyData({
					name: data.name,
				});
				setIsEditing(true);
			}
		} catch (error) {
			console.error(error);
		}
	};

	const handleDeleteFaculty = async (event) => {
		event.preventDefault();
		if (!facultyId) {
			alert('Please select a faculty to delete');
			return;
		}

		try {
			const response = await fetch(`${baseUrl}/api/faculty/${facultyId}`, {
				method: 'DELETE',
				headers: {
					'Content-Type': 'application/json',
					Authorization: `Bearer ${Cookie.get('token')}`,
				},
			});

			if (response.ok) {
				alert('Faculty deleted successfully');
				setFacultyId('');
				setFacultyData({ name: '' });
				fetchFaculties();
			} else {
				alert('Error deleting faculty');
			}
		} catch (error) {
			alert('Error deleting faculty');
		}
	};

	return (
		<div className='flex justify-center gap-4 items-center flex-wrap container my-6 mt-36'>
			<form
				className='tagForm bg-white p-6 rounded-lg shadow-md w-full  border-2 border-main flex flex-row flex-wrap gap-4 my-4'
				onSubmit={handleSubmitForm}>
				<h2 className='text-2xl text-main font-bold mb-4 w-full'>
					{isEditing ? 'Edit Faculty' : 'Create Faculty'}
				</h2>
				<div className='flex flex-col w-full md:w-1/3'>
					<label className='text-main'> {t('name')}</label>
					<input
						type='text'
						name='name'
						value={facultyData.name}
						onChange={handleInputsValue}
						placeholder='Name'
						className='block text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:outline-none p-2'
					/>
				</div>
				<button
					type='submit'
					className='w-auto bg-main text-white py-2 px-4 rounded-lg self-end'>
					{isEditing ? 'Update Faculty' : 'Create Faculty'}
				</button>
			</form>

			<form className='bg-white p-6 rounded-lg shadow-md w-full border-2 border-main flex flex-wrap gap-3'>
				<h2 className='text-main text-2xl font-bold w-full'>
					{t('editFaculty')}
				</h2>
				<select
					className='block w-full text-sm text-gray-700 border border-gray-300 rounded-lg bg-gray-50 focus:outline-none mb-4 p-2'
					value={facultyId}
					onChange={handleGetFacultyData}>
					<option value=''> {t('selectEditFaculty')}</option>
					{faculties.map((faculty) => (
						<option
							key={faculty.id}
							value={faculty.id}>
							{faculty.name}
						</option>
					))}
				</select>
			</form>

			<form
				className='bg-white p-6 rounded-lg shadow-md w-full  border-2 border-red-600 flex flex-wrap gap-3'
				onSubmit={handleDeleteFaculty}>
				<h2 className='text-red-600 text-2xl font-bold w-full'>
					{t('deleteFaculty')}
				</h2>
				<select
					className='block w-full text-sm text-gray-700 border border-gray-300 rounded-lg bg-gray-50 focus:outline-none mb-4 p-2'
					value={facultyId}
					onChange={handleGetFacultyData}>
					<option value=''>{t('selectDeleteFaculty')}</option>
					{faculties.map((faculty) => (
						<option
							key={faculty.id}
							value={faculty.id}>
							{faculty.name}
						</option>
					))}
				</select>
				<button
					type='submit'
					className='w-auto bg-red-600 text-white py-2 px-4 rounded-lg '>
					{t('deleteFaculty')}
				</button>
			</form>
		</div>
	);
}

export default AddFaculty;
